import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3bf07dd4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-outline mb-4" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "uploadName"
}, "Project name", -1))
const _hoisted_3 = { class: "form-outline mb-4" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "uploadName"
}, "Coordinate system", -1))
const _hoisted_5 = { class: "form-check form-switch mb-4 ps-0" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "custom-location"
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Specify custom project location", -1))
const _hoisted_8 = ["disabled"]

import ModalDialog from "@/components/Modals/ModalDialog.vue";
import CoordinateSystemPicker from "../Inputs/CoordinateSystemPicker.vue";
import { useDataStore } from "@/store/data-store";
import { CoordinateSystem } from "@/swagger/models/CoordinateSystem";
import { reactive, ref } from "vue";
import { useRoute } from "vue-router";
import MapLocationPicker from "@/components/Controls/MapLocationPicker.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'NewProjectDialog',
  emits: ["onHide"],
  setup(__props, { expose, emit }) {

const locationPicker = ref();
const route = useRoute();
const dataStore = useDataStore();

let data = reactive({
	name: null as string,
	show: false,
	customLocation: false,
	coordinateSystem: null as CoordinateSystem,
	latLong: null as number[]
})



async function show() {
	data.show = true;
	if(route.query.projectName){
		data.name = route.query.projectName as string;
	}
	if(route.query.crsCode){
		var coordinateSystems = await dataStore.getCoordinateSystems(route.query.crsCode as string);
		if(coordinateSystems.length > 0){
			data.coordinateSystem = coordinateSystems[0];
		}
	}
	if(route.query.lat && route.query.long){
		data.latLong = [parseFloat(route.query.lat as string), parseFloat(route.query.long as string)];
	}
}

function hide() {
	data.show = false;
}

async function create() {
	var latLong = data.customLocation ? locationPicker.value.getLocation() : data.latLong;
	const project = await dataStore.createProject(data.name, data.coordinateSystem?.id, latLong);
	console.log("Create project result", project);
	data.show = false;
	emit("onHide", project);
}

expose({
	show
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalDialog, {
    visible: _unref(data).show,
    title: "Create new project"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _withDirectives(_createElementVNode("input", {
            name: "uploadName",
            type: "text",
            class: "form-control",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(data).name) = $event))
          }, null, 512), [
            [_vModelText, _unref(data).name]
          ])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(CoordinateSystemPicker, {
            modelValue: _unref(data).coordinateSystem,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(data).coordinateSystem) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _hoisted_7,
          _withDirectives(_createElementVNode("input", {
            class: "form-check-input float-end",
            type: "checkbox",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(data).customLocation) = $event)),
            id: "custom-location"
          }, null, 512), [
            [_vModelCheckbox, _unref(data).customLocation]
          ])
        ]),
        (_unref(data).customLocation)
          ? (_openBlock(), _createBlock(MapLocationPicker, {
              key: 0,
              ref_key: "locationPicker",
              ref: locationPicker,
              class: "location my-3"
            }, null, 512))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            class: "btn-link me-4",
            onClick: hide
          }, "Cancel"),
          _createElementVNode("button", {
            disabled: !_unref(data).name,
            class: "btn",
            onClick: create
          }, "Create", 8, _hoisted_8)
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})